import { createTestIds } from '../../utils';

export const getAvatarTestIds = createTestIds('avatar', [] as const);
